export default __webpack_public_path__ + "static/media/123.66aab993.png";